<template>
  <div class="layout-container">
    <!-- 导航栏 -->
    <nav>
      <img id="logo" :src="baseUrl + logo" v-if="logo">
      <aside ref="aside">
        <ul id="menu">
          <li v-for="item, index in menuList" :key="index" :data-menuanchor="item.code"
            :class="index === 0 ? 'active' : ''" @click="handleMove(index)">
            <a :href="'#' + item.code">{{ item.name }}</a>
          </li>
        </ul>
        <el-badge :is-dot="Boolean(msgList.length)">
          <i class="el-icon-bell" @click="drawerVisible = !drawerVisible"></i>
        </el-badge>
        <el-dropdown trigger="click">
          <span class="el-dropdown-link">
            <img :src="userInfo.headUrl ? baseUrl + userInfo.headUrl : require('../assets/avatar.jpg')">
            <span class="username">{{ userInfo.name }}</span>
          </span>
          <el-dropdown-menu slot="dropdown" class="home-dropdown">
            <el-dropdown-item icon="el-icon-user" @click.native="$router.push('/personal')">个人设置</el-dropdown-item>
            <el-dropdown-item icon="el-icon-switch-button" @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </aside>
    </nav>
    <!-- 滚动页 -->
    <full-page v-if="appList.length" :options="options" ref="fullPage">
      <div id="content">
        <div class="section">
          <Home :pageIndex="pageIndex" :appList="appList" :clickApp="clickApp" @click.native="drawerVisible = false" />
        </div>
        <div class="section" v-for="item, index in appList" :key="item.code">
          <Apps :appIndex="index" :appList="appList" :clickApp="clickApp" @click.native="drawerVisible = false" />
        </div>
      </div>
    </full-page>
    <!-- 侧边栏 -->
    <div class="drawer" ref="drawer">
      <a class="first flex-row" :href="jumpURL + '/systemReminder'" target="_blank">
        <span>进入【系统提醒】查看更多</span>
        <i class="el-icon-right"></i>
      </a>
      <div class="msg-item flex-row" v-for="item in msgList" @click="viewMsg(item)">
        <div class="date">
          <div class="day">{{ item.sendTime.substring(8, 10) }}</div>
          <div class="year-month">{{ item.sendTime.substring(0, 7) }}</div>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="content">
          <div class="top flex-row">
            <div class="title">{{ item.title }}</div>
            <div class="time">{{ item.sendTime.substring(11, 19) }}</div>
          </div>
          <div class="detail">{{ item.content }}</div>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <div class="dialog" ref="dialog" @click.self="msgVisible = false">
      <div class="dialog-body">
        <div class="dialog-title">{{ dialogInfo.title }}</div>
        <div class="dialog-content" v-html="dialogInfo.content"></div>
        <div class="dialog-footer">
          <div class="type">{{ dialogInfo.kindView }}</div>
          <div class="time">{{ dialogInfo.sendTime }}</div>
        </div>
      </div>
    </div>
    <!-- 安全提示 -->
    <el-dialog :visible.sync="dialogVisible" title="修改密码" width="500px" class="safe-dialog">
      <el-result icon="warning" title="安全提示">
        <template slot="icon">
          <i class="el-icon-lock" style="font-size: 50px"></i>
        </template>
        <template slot="subTitle">
          <div class="flex-column" style="gap:10px">
            <b>您已长时间未修改密码，为了您的账户安全，建议您更新密码。</b>
          </div>
        </template>
        <template slot="extra">
          <el-form :model="form" :rules="rules" ref="form">
            <el-form-item label="原始密码" prop="password">
              <el-input size="medium" type="password" show-password v-model="form.password"
                placeholder="请输入原始密码"></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input size="medium" type="password" show-password v-model="form.newPassword"
                placeholder="请输入新密码"></el-input>
            </el-form-item>
            <el-form-item label="确认新密码" prop="confirmPassword">
              <el-input size="medium" type="password" show-password v-model="form.confirmPassword"
                placeholder="请输入确认密码"></el-input>
            </el-form-item>
          </el-form>
        </template>
      </el-result>
      <span slot="footer">
        <el-button size="medium" type="primary" @click="confirm">确定</el-button>
        <el-button size="medium" @click="dialogVisible = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const { jumpURL } = projectConfig
import cloneDeep from 'lodash.clonedeep'
import { getUserInfoApi, getConfigInfoApi, getAppListApi, getTipListApi, logUserClickApi, getSystemParamApi } from './api'
import { updatePasswordApi } from '../views/personal/api'
import Home from '../views/home'
import Apps from '../views/apps'
export default {
  name: 'Layout',
  components: { Home, Apps },
  data() {
    var validateConfirmPassword = (rule, value, callback) => {
      if (value) {
        if (value === this.form.newPassword) {
          callback()
        } else {
          callback(new Error('两次输入的密码不一致'))
        }
      } else {
        callback(new Error('确认密码不能为空'))
      }
      callback()
    }
    return {
      jumpURL,
      baseUrl: localStorage.getItem('baseUrl'),
      logo: localStorage.getItem('logo'),
      userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
      options: {
        menu: '#menu',
        anchors: [],
        lockAnchors: true,
        navigation: true,
        navigationPosition: 'left',
        navigationTooltips: [],
        keyboardScrolling: true,
        normalScrollElements: '.scroll,.drawer,.dialog,.el-dialog__wrapper',
        onLeave: this.onLeave
      },
      menuList: [],
      appList: [],
      pageIndex: 0,
      drawerVisible: false,
      msgList: [],
      msgVisible: false,
      dialogInfo: {},
      dialogVisible: false,
      form: {
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        password: [{ required: true, message: '原始密码不能为空', trigger: 'change' }],
        newPassword: [{ required: true, message: '新密码不能为空', trigger: 'change' }],
        confirmPassword: [{ required: true, validator: validateConfirmPassword, trigger: 'change' }]
      }
    }
  },
  watch: {
    drawerVisible(val) {
      this.$refs.drawer.style.opacity = val ? 1 : 0
      this.$refs.drawer.style.width = val ? 'calc(501*var(--ratio))' : 0
    },
    msgVisible(val) {
      this.$refs.dialog.style.clipPath = val ? 'polygon(0 0, 100% 0, 100% 100%, 0 100%)' : 'polygon(70% 0, 70% 0, 30% 100%, 30% 100%)'
    },
    pageIndex: {
      handler(val) {
        const aiNode = document.getElementById('n8n-chat')
        if (aiNode) aiNode.style.display = val === 6 ? 'block' : 'none'
      },
      immediate: true
    }
  },
  beforeCreate() {
    // 设备类型
    const isMobile = /Mobile|Android|iPhone/i.test(navigator.userAgent)
    if (isMobile) return window.location.href = `${jumpURL}/mobile/`
  },
  async created() {
    const { data } = await getUserInfoApi()
    this.userInfo = data
    localStorage.setItem('userInfo', JSON.stringify(data))
    if (data.initPassword) {
      this.dialogVisible = true
      const { data: { settingValue, settingDescription } } = await getConfigInfoApi('psd_regex')
      const regex = new RegExp(settingValue)
      this.rules.newPassword.push({
        validator: (rule, value, callback) => {
          if (!value) return callback()
          if (regex.test(value)) callback()
          else callback(new Error(settingDescription))
        },
        trigger: 'change'
      })
    }
    await this.getAppList()
    this.msgList = (await getTipListApi({ pageNo: 1, pageSize: 8, status: 0 })).rows
  },
  methods: {
    confirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          await updatePasswordApi(this.form)
          location.reload()
        }
      })
    },
    async getAppList() {
      const { data: { userOperationList } } = await getAppListApi({ platformType: 1 })
      this.appList = userOperationList.filter(item => item.children.length > 0)
      this.menuList = cloneDeep(this.appList)
      this.menuList.unshift({ code: 'home', name: '首页' })
      this.options.anchors = this.menuList.map(item => item.code)
      this.options.navigationTooltips = this.menuList.map(item => item.name)
    },
    async clickApp(sourceType, id, url) {
      await logUserClickApi({ idOperate: id, type: 1 })
      if (sourceType === 1) {
        url = jumpURL + url
      } else {
        const { data } = await getSystemParamApi(this.userInfo.id)
        for (const key in data) {
          url = url.replace(key, data[key])
        }
      }
      window.open(url)
    },
    async logout() {
      localStorage.clear()
      this.$router.push('/login')
    },
    handleMove(index) {
      this.$refs.fullPage.api.moveTo(index + 1, index)
    },
    handleScroll(state) {
      this.$refs.fullPage.api.setAllowScrolling(state)
    },
    onLeave(prevPage, nextPage) {
      this.pageIndex = nextPage.index
      this.drawerVisible = false
      this.msgVisible = false
      if (this.pageIndex === 0) {
        setTimeout(() => {
          this.$refs.aside.classList.remove('white')
          this.$refs.drawer.classList.remove('white')
        }, 100)
      } else {
        setTimeout(() => {
          this.$refs.aside.classList.add('white')
          this.$refs.drawer.classList.add('white')
        }, 500)
      }
    },
    viewMsg(item) {
      this.dialogInfo = item
      this.msgVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
// @import url('https://cdn.bootcdn.net/ajax/libs/fullPage.js/3.1.2/fullpage.css');

.layout-container {
  --ratio: calc(100vw / 1920);
  position: relative;
  background: no-repeat center/cover url('../assets/apps_bg.png');
  background-attachment: fixed;

  nav {
    width: 100%;
    display: flex;
    padding: calc(50*var(--ratio));
    position: fixed;
    z-index: 99;

    #logo {
      height: calc(40*var(--ratio));
    }

    aside {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: calc(60*var(--ratio));

      &.white {

        #menu,
        .el-icon-bell,
        .username {
          filter: grayscale(100) contrast(100) invert(100);
        }
      }

      #menu {
        display: flex;
        gap: calc(60*var(--ratio));

        li {
          display: flex;
          transition: 300ms ease-in-out;
          color: #656565;
          font-size: calc(18*var(--ratio));

          &.active {
            color: $homeRed;
            font-weight: bold;

            & a::after {
              width: 100%;
            }
          }

          &:hover:not(.active) {
            color: $homeRed;
          }

          a::after {
            display: block;
            content: '';
            width: 0;
            height: calc(3*var(--ratio));
            background: $homeRed;
            transition: 500ms ease-in-out;
            margin-top: calc(8*var(--ratio));
          }
        }
      }

      .el-icon-bell {
        font-size: calc(20*var(--ratio));
        color: $homeRed;
        transform: translateY(calc(-2*var(--ratio)));
        cursor: pointer;
        overflow: hidden;

        &:hover::after {
          left: 0;
        }

        &::after {
          content: '\e799';
          font-family: element-icons;
          position: absolute;
        }
      }

      .el-dropdown {
        cursor: pointer;
        transform: translateY(calc(-6*var(--ratio)));

        &:hover .username {
          color: $homeRed;
        }

        &-link {
          display: flex;
          align-items: center;
          gap: calc(10*var(--ratio));

          span {
            font-size: calc(16*var(--ratio));
            color: #656565;
          }

          img {
            width: calc(30*var(--ratio));
            height: calc(30*var(--ratio));
            border-radius: 50%;
          }
        }
      }
    }
  }

  .drawer {
    transform: translateX(1px);
    position: fixed;
    top: calc(90*var(--ratio));
    right: 0;
    width: 0;
    height: calc(100vh - 90*var(--ratio));
    border-left: 1px solid;
    border-image: linear-gradient(to top, #ddd 70%, transparent) 1;
    transition: 300ms ease-in-out;
    backdrop-filter: blur(10px);
    overflow: hidden;
    z-index: 99;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(auto-fill, minmax(calc(100*var(--ratio)), 1fr));

    &.white {
      background: linear-gradient(to top, #1850A250 70%, transparent);

      .first {
        color: #ddd;

        &:hover {
          color: #fff;
          background: linear-gradient(to left, #ffffff00, #ffffff30);
        }
      }

      .msg-item {
        .date {

          .day,
          .year-month {
            color: #ddd;
          }
        }

        .content {
          .top {

            .title,
            .time {
              color: #ddd;
            }
          }

          .detail {
            color: #ddd
          }
        }

        &:hover {
          background: linear-gradient(to left, #ffffff00, #ffffff30);

          .date {

            .day,
            .year-month {
              color: #fff;
            }
          }

          .content {
            .top {

              .title,
              .time {
                color: #fff;
              }
            }

            .detail {
              color: #fff
            }
          }
        }
      }
    }

    .first {
      font-size: calc(18*var(--ratio));
      justify-content: flex-start;
      white-space: nowrap;

      span {
        margin-left: calc(30*var(--ratio));
      }

      .el-icon-right {
        transform: translateX(calc(10*var(--ratio)));
        animation: iconMove 2s infinite;
        animation-play-state: paused;
      }

      &:hover {
        background: linear-gradient(to left, #676aff00, #6a67ff20);
        cursor: pointer;
        color: $homeBlue;

        i {
          animation-play-state: running;
        }
      }
    }

    .msg-item {

      &:hover {
        background: linear-gradient(to left, #676aff00, #6a67ff20);
        cursor: pointer;

        .date {

          .day,
          .year-month {
            color: $homeBlue;
          }
        }

        & .content {
          .top {

            .title,
            .time {
              color: $homeBlue;
            }
          }

          .detail {
            color: $homeBlue
          }
        }
      }

      .date {
        text-align: center;
        margin: 0 calc(20*var(--ratio)) 0 calc(30*var(--ratio));

        .day {
          font-size: calc(40*var(--ratio));
          font-family: math;
          line-height: 1;
          color: #999;
        }

        .year-month {
          font-size: calc(10*var(--ratio));
          color: #999;
        }
      }

      .el-divider {
        height: calc(50*var(--ratio));
      }

      .content {
        flex-grow: 1;
        width: 0;
        align-items: flex-start;
        margin: 0 calc(30*var(--ratio)) 0 calc(20*var(--ratio));

        .top {
          width: 100%;
          align-items: flex-start;

          .title {
            font-size: calc(20*var(--ratio));
            font-weight: bold;
            color: #333;
            flex-grow: 1;
            width: 0;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }

          .time {
            font-size: calc(12*var(--ratio));
            color: #666;
          }
        }

        .detail {
          font-size: calc(16*var(--ratio));
          width: 100%;
          color: #666;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          margin-top: calc(10*var(--ratio));
        }
      }
    }

    @keyframes iconMove {
      to {
        transform: translateX(calc(30*var(--ratio)));
      }
    }
  }

  .dialog {
    height: 100vh;
    width: 100vw;
    background: #00000080;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    transition: 300ms ease-in-out;
    overflow: hidden;
    display: flex;
    clip-path: polygon(70% 0, 70% 0, 30% 100%, 30% 100%);
    backdrop-filter: blur(10px);

    &-body {
      margin: auto;
      background: #fff;
      padding: calc(30*var(--ratio));
      width: 48vw;
      height: 70vh;
      position: relative;
      display: flex;
      flex-direction: column;
      border: calc(3*var(--ratio)) solid transparent;
      // background: linear-gradient(#fff, #fff) padding-box, repeating-linear-gradient(-45deg, $homeRed 0, $homeRed 12.5%, #fff 0, #fff 25%, $homeBlue 0, $homeBlue 37.5%, #fff 0, #fff 50%) 0/calc(80*var(--ratio)) calc(80*var(--ratio));

      .dialog-title {
        font-size: calc(22*var(--ratio));
        font-weight: bold;
        color: $titleColor;

        &::after {
          content: '';
          display: block;
          width: 100%;
          height: 1.5px;
          background: $hoverColor;
          margin-top: calc(10*var(--ratio));
        }
      }

      .dialog-content {
        width: 100%;
        margin: calc(20*var(--ratio)) 0;
        flex-grow: 1;
        font-size: calc(15*var(--ratio));
        color: $contentColor;
        line-height: calc(30*var(--ratio));
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow: auto;

        &::-webkit-scrollbar {
          display: none;
        }
      }

      .dialog-footer {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        &::before {
          content: '';
          display: block;
          width: 100%;
          height: 1.5px;
          background: $hoverColor;
          margin-bottom: calc(20*var(--ratio));
        }

        .type {
          color: $homeRed;
          font-weight: bold;
          font-size: calc(14*var(--ratio));
        }

        .time {
          color: $homeBlue;
          font-size: calc(14*var(--ratio));
          font-family: math;
        }
      }
    }
  }

  .safe-dialog {
    ::v-deep.el-dialog {
      border-radius: 0;

      .el-dialog__header {
        display: none;
      }

      .el-dialog__body {
        display: flex;
        justify-content: center;

        .el-form-item__label {
          color: $pointColor;
          font-weight: bold;
        }

        .el-input__inner {
          width: 400px;
          border-radius: 0;
        }
      }

      .el-dialog__footer {
        .el-button {
          border-radius: 0;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.home-dropdown {
  border-radius: 0 !important;
  box-shadow: none !important;

  .el-dropdown-menu__item:hover {
    background: none !important;
  }
}
</style>